import React, { Component } from 'react';
import { Redirect }         from "react-router-dom";
import Navbar               from './Navbar';
import { isAuthenticated }  from './Login'
import Avatar               from './Avatar';
import API                  from './server_api'
import { getMe, updateMe }  from './Login';

import TimeAgo              from 'react-timeago';
import ruStrings            from 'react-timeago/lib/language-strings/ru'
import buildFormatter       from 'react-timeago/lib/formatters/buildFormatter'


const formatter = buildFormatter(ruStrings);


function UserDescription (props) {
    const p = props.state;
    const editing = p.editing;

    // красивый список проектов пользователя
    let projs = [];
    if (p.project_names !== undefined){
        for (let i in p.project_names){
            projs.push(<strong key={i}>{p.project_names[i]}</strong>);
            if ( i < p.project_names.length-1 )
                projs.push(', ');
        }
    }

    return (
        <div className="border shadow-lg rounded-lg bg-white mt-4 p-4">
            <div className='d-flex'>
                { p.is_loaded && <Avatar email={p.email} size='120' className='pr-4' /> }
                <div className='flex-fill'>
                    { editing !== 'name' &&
                        <span className='d-flex justify-content-between'>
                            <h1 className="display-4 text-break">{p.name}</h1>
                            <button className='close' disabled={ p.is_deleting || !p.is_loaded }>
                                <img src='img/edit.svg' 
                                    className='align-self-start mt-0 ml-sm-5' 
                                    onClick={ p.is_deleting ? ()=>{} : props.clb.onEditNameButton } 
                                    alt='edit'/>
                            </button>
                        </span>
                    }
                    { editing === 'name' && 
                        <form className="form-inline mb-4" onSubmit={ props.clb.onNameChangeButton } autoComplete="off">
                            <div className="form-group flex-grow-1">
                                <input type="text" 
                                    className="form-control w-100 mr-2"
                                    id="nameEdit" 
                                    maxLength='50'
                                    autoFocus={true} 
                                    onChange={props.clb.handleInputChange}
                                    value={ p.nameEdit }/>
                            </div>
                            <div>
                                <button type="reset" className="btn btn-secondary mr-2" onClick={ props.clb.onCancelButton }>Отмена</button>
                                <button type="submit" className="btn btn-primary">Изменить</button>
                            </div>
                        </form>
                    }
                    <span className='d-flex justify-content-between'>
                        <p className="lead text-break">{p.email}</p>
                    </span>
                </div>
            </div>
            <hr className="my-4"/>
            { p.is_loaded && p.is_admin &&
                <div>
                    <p>Администратор сервиса. Имеет доступ к:</p>
                    <ul>
                        <li>Созданию и удалению проектов</li>
                        <li>Добавлению и удалению внешних пользователей</li>
                        <li>Управлению доступом внешних пользователей к проектам</li>
                        <li>Созданию новых папок в проектах</li>
                        <li>Скачиванию файлов из папок проекта</li>
                        <li>Загрузке новых файлов в папки</li>
                    </ul>
                </div>
            }
            { p.is_loaded && !p.is_admin &&
                <div>
                    <p>Пользователь сервиса. Имеет доступ к:</p>
                    <ul>
                        <li>Созданию новых папок в проектах</li>
                        <li>Скачиванию файлов из папок проекта</li>
                        <li>Загрузке новых вайлов в папки</li>
                    </ul>
                    { projs.length >0 && <p>Является участником следующих проектов: {projs}.</p> }
                    { projs.length === 0 && <p>В данный момент не участвует ни в одном из проектов.</p> }
                </div>
            }
            { !p.is_loaded || !getMe().is_admin || getMe().id === p.id ||
                <button className="btn btn-danger btn-lg mt-3" 
                disabled={ p.is_deleting } 
                onClick={ props.clb.onDeleteUser } >
                    Удалить пользователя
                </button>
            }
        </div>
    );
}


function ServerStatus (props) {

    // идет перезагрузка?
    if (typeof props.state === 'string')
    return (
        <div className="border  shadow-lg rounded-lg bg-white mt-4 p-4">
            <h1>Идет обновление сервера...</h1>
        </div>
    );



    // сторим список обновлений с момента запуска текуще версии
    let updates = [];
    for (let i in props.state.updates)
        updates.push(<li>(<strong>{props.state.updates[i].hash}</strong>) <i>'{props.state.updates[i].name}'</i></li>);

    return (
        <div className="border  shadow-lg rounded-lg bg-white mt-4 p-4">
            <h1>Статистика сервера</h1>
            <p>
                Стартовал <TimeAgo date={new Date(props.state.uptime_starts)} formatter={formatter} />.<br/>
                Текущая ревизия: (<strong>{props.state.current_hash}</strong>) <i>'{props.state.current_name}'</i>
                , закомичена <TimeAgo date={new Date(props.state.current_date)} formatter={formatter} />.<br/>
                { props.state.updates.length === 0 &&
                    <span>Доступных обновлений нет.</span>
                }
            </p>
            { props.state.updates.length > 0 && <div>
                <h3>Доступны обновления:</h3>
                <ul> {updates} </ul>
                <button className="btn btn-danger btn-lg mt-3"
                    onClick={ props.clb } >
                        Обновить
                </button>
            </div> }
        </div>
    );
}



export default class User extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_loaded:   false,
            editing:     'none',
            name:        '',
            email:       '',
            is_deleting:  false,     // отослан запрос на удаление пользователя
            is_deleted:   false,     // пришел ответ, что пользователь удален
            me:           getMe(),
            version_info: null,      // информация о версии серверного приложения
        };

        // способ отслеживания изменения URI и загрузи правильных данных
        this.cached_id = this.props.match.params.id;

        this.handleInputChange     = this.handleInputChange.bind(this);
        this.onEditNameButton      = this.onEditNameButton.bind(this);
        this.onNameChangeButton    = this.onNameChangeButton.bind(this);
        this.onCancelButton        = this.onCancelButton.bind(this);
        this.onDeleteUser          = this.onDeleteUser.bind(this);
        this.onUpdateServer        = this.onUpdateServer.bind(this);
    }

    loadUserInfo(){
        // загружаем информацию о пользователе
        API.getUser( (json)=>{ 
            json.is_loaded = true; // информация наконец загружена
            this.setState( json ); 
            // загружаем информацию о версии сервера, если это страница админа
            if ( this.state.me.is_admin && this.state.me.email === json.email )
                API.getVersion( (json2) => this.setState( { version_info: json2 }) );
        }, this.props.match.params.id );
    }

    componentWillMount() {
        if ( isAuthenticated() )
            this.loadUserInfo();
    }

    componentDidUpdate(){
        // отслеживаем изменение ссылки, чтобы перезагрузить информацию о пользователе
        if ( this.cached_id !== this.props.match.params.id ){
            this.cached_id = this.props.match.params.id;
            this.setState({ is_loaded: false })
            this.loadUserInfo();
        }
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState({ [target.id]: target.value });
    }

    onEditNameButton (event) {
        this.setState( { editing: 'name', nameEdit: this.state.name });
    }

    onNameChangeButton (event) {
        this.setState({ editing: 'none' });
        API.updateUserName( ()=>{ 
            // если редактируем себя - обновляем
            if ( getMe().id === this.props.match.params.id ) {
                let json = getMe();
                json.name = this.state.nameEdit;
                updateMe(json);
            }
            this.setState({name: this.state.nameEdit, me: getMe()}); 
        }, this.props.match.params.id, this.state.nameEdit );
        event.preventDefault();
    }

    onCancelButton (event) {
        this.setState( { editing: 'none' });
    }

    onDeleteUser (event) {
        this.setState( { editing: 'none', is_deleting: true });
        API.deleteUser(()=>{ this.setState( { is_deleted: true }); }, this.props.match.params.id);
        event.preventDefault();
    }

    onUpdateServer (event) {
        API.updateServer(()=>{
            // отрисовываем статус обновления сервера
            this.setState({ version_info: 'updating'});
            setTimeout( ()=>{
                // после обновления снова рисуем информацию о версии
                API.getVersion( (json2) => this.setState( { version_info: json2 }) );
            }, 15000);
        });
    }

    render () {
        // неавторизованных пользователей перенаправляем на страницу логина
        if ( !isAuthenticated() )
            return (<Redirect to={{ pathname: "/login", state: { from: this.props.location }}} />);

        // после удаление проекта переходим к списку проектов снова
        if ( this.state.is_deleted )
            return (<Redirect to='/' />);
        
        return ([
            <Navbar key='navbar' me={this.state.me} />,
            <main key='body' role="main" className="container">
                <UserDescription state= {this.state} clb={this} />
                { this.state.version_info &&
                    <ServerStatus state= {this.state.version_info} clb={this.onUpdateServer} /> 
                }
            </main>
        ]);
    }
}
